import type { Catalog } from "../../en";

/** Filipino: Announcements (/w/:ws/announcements) (mirrors en). */
export const announcements: Catalog["engage"]["announcements"] = {
  title: "Mga anunsyo",
  subtitle: "Magpadala ng mahalagang balita sa app mo, i-pin ito sa chat widget, at ituro sa assistant para masagot nito ang mga follow-up na tanong.",
  newAnnouncement: "Bagong anunsyo",
  stats: {
    reachable: "Naaabot na app install",
    reachableNone: "Wala pang naka-register na app install",
    sentThisMonth: "Naipadala ngayong buwan",
    pipeline: "{{scheduled}} naka-schedule · {{drafts}} draft",
    avgOpenRate: "Average na open rate",
    openRateHint: "sa lahat ng naipadalang anunsyo",
    followUps: "Nasagot na follow-up na tanong",
    followUpsHint: "ng assistant, mula sa mga anunsyo",
  },
  views: {
    label: "I-filter ang mga anunsyo",
    all: "Lahat",
    sent: "Naipadala",
    scheduled: "Naka-schedule",
    draft: "Mga draft",
    archived: "Naka-archive",
  },
  search: "Maghanap ng anunsyo…",
  status: {
    sent: "Naipadala",
    sending: "Ipinapadala…",
    scheduled: "Naka-schedule · {{when}}",
    draft: "Draft",
    archived: "Naka-archive",
  },
  urgent: "Urgent",
  byline: "{{when}} ni {{name}}",
  bylineNoName: "{{when}}",
  createdBy: "ni {{name}}",
  lastEdited: "Huling na-edit {{when}}",
  lastEditedBy: "Huling na-edit {{when}} ni {{name}}",
  audienceSeparator: " · ",
  channels: {
    push: "Mobile push",
    webapp_banner: "Banner sa web app",
    widget_pin: "Naka-pin sa widget",
    email: "Email",
  },
  taught: "Itinuro sa assistant",
  taughtExpires: "Itinuro sa assistant · mag-e-expire {{date}}",
  teachesOnSend: "Ituturo sa assistant pagkapadala",
  notTaught: "Hindi pa itinuturo sa assistant",
  delivered: "Naihatid",
  opened: "Nabuksan",
  aiAnswers: "Sagot ng AI",
  openBar: "{{rate}} ang nagbukas sa {{delivered}} na naihatid",
  estimatedReach: "Tantyang maaabot",
  devices_one: "{{count}} device",
  devices_other: "{{count}} device",
  sendsIn: "Ipapadala sa loob ng",
  days_one: "{{count}} araw",
  days_other: "{{count}} araw",
  hours_one: "{{count}} oras",
  hours_other: "{{count}} oras",
  actions: {
    sendNow: "Ipadala na",
    duplicate: "I-duplicate",
    edit: "I-edit",
    continueEditing: "Ituloy ang pag-edit",
    archive: "I-archive",
    restore: "Ibalik",
    delete: "Burahin",
  },
  toasts: {
    sentNow: "Naipadala na",
    duplicated: "Na-duplicate bilang draft",
    archived: "Na-archive · inalis sa widget at sa kaalaman ng assistant",
    restored: "Naibalik",
    deleted: "Nabura ang draft",
    draftSaved: "Na-save ang draft",
    scheduled: "Naka-schedule na ang anunsyo",
    scheduledTeach: "Naka-schedule na ang anunsyo · matututunan ito ng assistant pagkapadala",
    sent: "Naipadala ang anunsyo",
    sentTeach: "Naipadala ang anunsyo · na-update ang assistant",
    failed: "Hindi ito gumana. Pakisubukang muli.",
  },
  emptyTitle: "Walang anunsyo rito",
  emptyBody: "Ibahagi ang balita sa audience mo sa app, web app, widget at email.",
  emptySearchBody: "Sumubok ng ibang paghahanap o filter.",
  loadError: "Hindi ma-load ang mga anunsyo.",
  statsError: "Hindi ma-load ang stats ng mga anunsyo.",
  composer: {
    newTitle: "Bagong anunsyo",
    editTitle: "I-edit ang anunsyo",
    titleLabel: "Pamagat",
    titlePlaceholder: "hal. Sarado ang opisina bukas dahil sa Bagyong Ofel",
    titleRequired: "Maglagay ng pamagat",
    messageLabel: "Mensahe",
    messageCounter: "{{count}} / {{max}} · unang {{push}} lang ang lalabas sa push",
    messagePlaceholder: "Isulat na parang text message — maikli, malinaw, may petsa at kung ano ang gagawin.",
    messageRequired: "Maglagay ng mensahe",
    urgent: "Markahan bilang urgent",
    audience: "Audience",
    audienceRequired: "Pumili ng kahit isang audience",
    segments: "Mga segment",
    segmentsHint: "Opsyonal. Paliitin ang audience sa mga segment na itinakda mo (hal. grupo, branch o antas).",
    addSegment: "Magdagdag ng segment",
    segmentPlaceholder: "Bagong segment",
    channels: "Mga channel",
    channelHints: {
      push: "Ang app mo sa iOS at Android",
      webapp_banner: "Itaas ng web app mo",
      widget_pin: "Lalabas pagbukas ng chat sa website mo",
      email: "Sa mga naka-register na email address",
    },
    when: "Kailan ipapadala",
    sendNow: "Ipadala ngayon",
    schedule: "I-schedule",
    date: "Petsa",
    time: "Oras",
    timeZoneHint: "Time zone: {{zone}}",
    scheduleInvalid: "Pumili ng oras ng pagpapadala sa hinaharap",
    teachTitle: "Ituro rin sa assistant ang impormasyong ito",
    teachLabel: "Ituro sa assistant",
    teachHelp: "Idinadagdag ang anunsyo sa Knowledge Base bilang pansamantalang source. Kapag may nagtanong ng follow-up, sasagot ang assistant mula sa anunsyong ito at sisipiin ito, sa halip na sabihing hindi nito alam.",
    forgetAfter: "Kalimutan pagkalipas ng",
    expiry: {
      "2d": "2 araw",
      "1w": "1 linggo",
      endOfMonth: "Katapusan ng buwan",
      never: "Hindi kailanman",
    },
    agents: "Mga agent",
    pushPreview: "Preview ng push",
    pinPreview: "Naka-pin na mensahe sa widget",
    previewNow: "ngayon",
    previewGreeting: "Hi! Paano kita matutulungan?",
    reach: "Tantyang maaabot: {{devices}} · {{emails}}",
    reachPending: "Tinatantya ang maaabot…",
    emails_one: "{{count}} email",
    emails_other: "{{count}} email",
    saveDraft: "I-save ang draft",
    send: "Ipadala ang anunsyo",
    scheduleSubmit: "I-schedule ang anunsyo",
    noSendPermission: "Puwede kang mag-save ng draft. Kailangan ng send permission para makapagpadala.",
  },
};
